import moment from "moment";
import { Toolbar } from "ngx-editor";

export const sortCatalogo: any = (oCatalogo: [], campo: string) => {
    let catOrdenado = oCatalogo.sort(function(a:any, b:any){
        if(a[campo].toLowerCase() < b[campo].toLowerCase()) { return -1; }
        if(a[campo].toLowerCase() > b[campo].toLowerCase()) { return 1; }
        return 0;
    });
    
    return catOrdenado;
}

export const downloadFile: any = (data: BlobPart, nombre = 'reporte') => {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let fileName = `${nombre} - ${moment().format('YYYY/MM/DD HH:mm:ss')}.xlsx`;
    var link = document.createElement("a");

    link.id = `file_${getRandomNumber()}`;
    console.log(link.id);
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    // Revocar el objeto URL y eliminar el elemento por clase
    setTimeout(() => {
      window.URL.revokeObjectURL(link.href);
      const elements = document.getElementById(link.id);
      elements?.remove();
    }, 2000);
}

export const getRandomNumber: any = (min: number = 1000, max: number = 9000) => {
    return Math.random() * (max - min) + min;
}

export const toolbarEditor: Toolbar = [
  [{heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
  ['bold', 'italic', 'strike','text_color', 'background_color'],
  ['link'],
  ['align_left', 'align_center', 'align_right', 'align_justify'],
  ['outdent', 'indent'],
  ['format_clear', 'image'],
  ['underline', 'code', 'blockquote'],
  ['ordered_list', 'bullet_list'],
  //['ordered_list', 'bullet_list', 'horizontal_rule'],
  ['superscript', 'subscript'],
  ['undo', 'redo'],
];

export const localsEditor = {
  bold: 'Bold',
  italic: 'Italic',
  code: 'Code',
  blockquote: 'Blockquote',
  underline: 'Underline',
  strike: 'Strike',
  bullet_list: 'Bullet List',
  ordered_list: 'Ordered List',
  heading: 'Paragraph',
  h1: 'Header 1',
  h2: 'Header 2',
  h3: 'Header 3',
  h4: 'Header 4',
  h5: 'Header 5',
  h6: 'Header 6',
  align_left: 'Left Align',
  align_center: 'Center Align',
  align_right: 'Right Align',
  align_justify: 'Justify',
  text_color: 'Text Color',
  background_color: 'Background Color',
  url: 'URL',
  text: 'Text',
  openInNewTab: 'Open in new tab',
  insert: 'Insert',
  altText: 'Alt Text',
  title: 'Title',
  remove: 'Remove',
  enterValidUrl: 'Please enter a valid URL',
};

export const resolveAfterSeconds: any = (seconds: number = 1, data: any = true) => {
  const timer = seconds * 1000;
  return new Promise((resolve) => {
    setTimeout(() => { resolve(data); }, timer);
  });
}

/////////////////////////////////////////////////////////////////////////////
// ANGULAR EQUALS
/////////////////////////////////////////////////////////////////////////////
var toString = Object.prototype.toString;

export const isDefined = (value: any) => {return typeof value !== 'undefined';}
export const isFunction = (value: any) => {return typeof value === 'function';}
export const createMap = () => {return Object.create(null);}
export const isWindow = (obj: any) => {return obj && obj.window === obj;}
export const isScope = (obj: any) => {return obj && obj.$evalAsync && obj.$watch;}
export const isRegExp = (value: any) => {return toString.call(value) === '[object RegExp]';}
export const simpleCompare = (a: any, b: any) => { return a === b || (a !== a && b !== b); }
export const isDate = (value: any) => {return toString.call(value) === '[object Date]';}
export const isArray = (arr: any) => {return Array.isArray(arr) || arr instanceof Array;}

export const equals = (o1: any, o2: any) => {
  if (o1 === o2) return true;
  if (o1 === null || o2 === null) return false;
  // eslint-disable-next-line no-self-compare
  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
  if (t1 === t2 && t1 === 'object') {
    if (isArray(o1)) {
      if (!isArray(o2)) return false;
      if ((length = o1.length) === o2.length) {
        for (key = 0; key < length; key++) {
          if (!equals(o1[key], o2[key])) return false;
        }
        return true;
      }
    } else if (isDate(o1)) {
      if (!isDate(o2)) return false;
      return simpleCompare(o1.getTime(), o2.getTime());
    } else if (isRegExp(o1)) {
      if (!isRegExp(o2)) return false;
      return o1.toString() === o2.toString();
    } else {
      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
      keySet = createMap();
      for (key in o1) {
        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
        if (!equals(o1[key], o2[key])) return false;
        keySet[key] = true;
      }
      for (key in o2) {
        if (!(key in keySet) &&
            key.charAt(0) !== '$' &&
            isDefined(o2[key]) &&
            !isFunction(o2[key])) return false;
      }
      return true;
    }
  }
  return false;
}

/////////////////////////////////////////////////////////////////////////////
// TIME
/////////////////////////////////////////////////////////////////////////////
export const getTimeConsole = () => {
  const date =  new Date();
  const getTimeConsole = date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds() + ':'  + date.getMilliseconds();
  return getTimeConsole;
}

/////////////////////////////////////////////////////////////////////////////
// TIMEOUT
/////////////////////////////////////////////////////////////////////////////
export const createTimeout = async (ms: number): Promise<any> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve('Timeout Exceeded');
    }, ms);
  });
}